import { Col, Row, Skeleton } from "antd";
import React, { FC, useEffect, useState } from "react";
import "./contentMetrics.scss";
import { DownloadOutlined } from "@ant-design/icons";
import VideosIcon from "../../../assets/icons/videos.svg";
import PdfIcon from "../../../assets/icons/total-pdf.svg";
import QuickQuizIcon from "../../../assets/icons/checklist.svg";
import ExerciseIcon from "../../../assets/icons/exercise.svg";
import DashboardService from "../../../services/DashboardService/dashboard.service";
import { StudentMetricsModel } from "../../../models/DashboardModel/StudentMetricsModel/studentMetrics.model";
import ButtonComponent from "../../../shared/components/ButtonComponent";

interface ContentMetricsProps { }

const ContentMetrics: FC<ContentMetricsProps> = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const [metrics, setMetrics] = useState<StudentMetricsModel>({});
  const [loading, setLoading] = useState(false);

  const fetchStudentMetrics = () => {
    DashboardService.fetchStudentMetrics(
      (metrics) => {
        setMetrics(metrics);
        setIsLoading(false);
      },
      () => { },
      () => { }
    );
  };

  useEffect(() => {
    fetchStudentMetrics();
  }, []);

  // Download Report 
  const handleDownload = (params?: any) => {
    setLoading(true)
    DashboardService.downloadStudentContentMetrics(
      (contents) => { },
      () => { },
      () => { setLoading(false) }
    );
  }

  return (
    <div className="content-metrics">
      <div className="content-metrics__header">
        <div className="content-metrics__title">Content Metrics</div>
        <ButtonComponent
          disabled={loading}
          type="text"
          iconLeft={<DownloadOutlined />}
          buttonContent="Downlaod Report"
          onClick={() => handleDownload()}
        />
      </div>
      <Row className="content-metrics__wrapper" gutter={[24, 24]}>
        <Col span={8}>
          <div className="content-metrics__card videos">
            <div className="content-metrics__card-icon">
              <img src={VideosIcon} />
            </div>
            <div className="content-metrics__card-content">
              <p className="title">Total Videos</p>
              {isLoading ? (
                <Skeleton active paragraph={{ rows: 0 }} />
              ) : (
                <p className="value">{metrics?.totalVideos}</p>
              )}
            </div>
          </div>
        </Col>
        <Col span={8}>
          <div className="content-metrics__card pdf">
            <div className="content-metrics__card-icon">
              <img src={PdfIcon} />
            </div>
            <div className="content-metrics__card-content">
              <p className="title">Total PDF</p>
              {isLoading ? (
                <Skeleton active paragraph={{ rows: 0 }} />
              ) : (
                <p className="value">{metrics?.totalPdfs}</p>
              )}
            </div>
          </div>
        </Col>
        <Col span={8}>
          <div className="content-metrics__card quick-quiz">
            <div className="content-metrics__card-icon">
              <img src={QuickQuizIcon} />
            </div>
            <div className="content-metrics__card-content">
              <p className="title">Quick Quiz</p>
              {isLoading ? (
                <Skeleton active paragraph={{ rows: 0 }} />
              ) : (
                <p className="value">{metrics?.totalQuickQuiz}</p>
              )}
            </div>
          </div>
        </Col>
        <Col span={8}>
          <div className="content-metrics__card exercise">
            <div className="content-metrics__card-icon">
              <img src={ExerciseIcon} />
            </div>
            <div className="content-metrics__card-content">
              <p className="title">Exercise</p>
              {isLoading ? (
                <Skeleton active paragraph={{ rows: 0 }} />
              ) : (
                <p className="value">{metrics?.totalExcercises}</p>
              )}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ContentMetrics;
